export const WAYPOINT_TYPE_PRIVATE = 'private';
export const WAYPOINT_TYPE_CUSTOMER = 'customer';
export const WAYPOINT_MARKED = 'marked';
export const WAYPOINT_TYPE_DEFAULT = 'default';
export const WAYPOINT_WORD_LENGTH = 18;
export const WAYPOINT_QUERY_KEY = 'waypointsData';
